import Cookies from "js-cookie"

// Date and time formatter
const formatDate1 = (dateStr) => {
  const date = new Date(dateStr)

  const formattedDate = new Intl.DateTimeFormat("en-Gb", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }).format(date)

  return formattedDate
}

const formatDate2 = (dateStr) => {
  const date = new Date(dateStr)

  const formattedDate = new Intl.DateTimeFormat("en-Gb", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  }).format(date)

  return formattedDate
}

const formatDate3 = (utcTimestamp) => {
  const date = new Date(utcTimestamp);

  return date.toISOString().slice(0, 10);
}

const convertToDateOnly = (dateStr) => {
  const date = new Date(dateStr)

  return date.getDate().toString().padStart(2, "0")
}

const convertToDateMonth = (dateStr) => {
  const dateX = new Date(dateStr)

  const date = dateX.getDate().toString().padStart(2, "0")
  const month = dateX.toLocaleString("en-En", { month: "short" })

  return `${date} ${month}`
}

const formatTime1 = (timeStr) => {
  return timeStr.replace(":", ".")
}

const formatTime2 = (utcTimestamp) => {
  const date = new Date(utcTimestamp);

  const formattedTime = date.toLocaleString("sv-SE", {
    timeZone: "Asia/Makassar",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).replace("T", " ");

  return formattedTime
}

// handle text formatting
const capitalizeFirstLetter = (str) => {
  const strArr = str.split(", ")

  const capitalizedText = strArr
    .map(text => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase())
    .join(', ');

  return capitalizedText
}

// handle price formatting
const formatNumber = (price) => {
  return price.toLocaleString("id-ID")
}

const handleNegativeVal = (num) => {
  return num.replace(/[^0-9]/g, '')
}

const getRandomObjects = (arr, count) => {
  return arr.sort(() => Math.random() - 0.5).slice(0, count)
}

// handle error messages
const getError = (err) => {
  let errs = []

  if (err.response) {
    if (err.response.data.errors) {
      const entries = Object.entries(err.response.data.errors)
      entries.forEach(([key, val]) => {
        errs.push({ path: [key], message: val[0] })
      })
    } else {
      errs.push(err.response.data.message)
    }
  } else {
    let errX = ""
    if (typeof err == "string") {
      errX = err
    } else {
      errX = err.message
    }
    errs.push(errX)
  }

  return { error: errs }
}

const handleError = (err) => {
  let currPath = ""
  const errMap = new Map()

  for (let i = 0; i < err.error.length; i++) {
    const path = err.error[i].path ? err.error[i].path[0] : Object.keys(err.error[i].errors)
    // const path = err.error[i].path ? err.error[i].path[0] : "error"
    const currErrors = errMap.get(path) || []

    if (currPath == path) continue

    errMap.set(path, [...currErrors, err.error[i].message])
    currPath = path
  }

  const newErrs = {}
  errMap.forEach((mss, path) => {
    newErrs[path] = mss.join(", ")
  })

  return newErrs
}

const removeCookies = () => {
  Cookies.remove("accessToken")
  Cookies.remove("user")
  Cookies.remove("categoryId")
  Cookies.remove("productId")
  Cookies.remove("productsPage")
  Cookies.remove("shippingDetail")
}

export {
  getError,
  handleError,
  formatDate1,
  formatDate2,
  formatDate3,
  formatTime1,
  formatTime2,
  convertToDateOnly,
  convertToDateMonth,
  formatNumber,
  handleNegativeVal,
  getRandomObjects,
  capitalizeFirstLetter,
  removeCookies
}